// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___d5f67e6b2439aa611ac","cls2":"CreateSocialItemModal-cls2___df6024ffa4d58da3e73 CreateSocialItemModal-cls1___d5f67e6b2439aa611ac"};